const DEPENDENCY_SECURITY_ROOT = '/dependency-security';

export const DEPENDENCY_SECURITY_ROUTES = {
  root: {
    title: 'Dependency Security',
    path: DEPENDENCY_SECURITY_ROOT,
  },
} as const;
